<script>import useStyles from './CardSection.styles';
import { Box } from '../../Box';
export let use = [], element = undefined, className = '', override = {}, padding = 'md';
export { className as class };
$: ({ cx, classes, getStyles } = useStyles({ padding }));
</script>

<Box
	id="svelteui_card_section"
	bind:element
	class={cx(className, classes.root, getStyles({ css: override }))}
	{use}
	{...$$restProps}
>
	<slot />
</Box>
